export const SET_CASHIERS = 'setCashiers'
export const FETCH_START = 'fetchStart'
export const FETCH_END = 'fetchEnd'